import { defaultTo, omit } from 'lodash';
import client from '../../httpClient';

export const TendersCreate = async (payload) => client.post(
  `/merchants/tenders/${payload.tender}`,
  defaultTo(omit(payload, 'tender'), { merchants: {} }),
);
